/* =========================================================================================
  File Name: moduleContext.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
========================================================================================== */

import state from './state'
import mutations from './mutation'
import actions from './action'
import getters from './getter'

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
